import axios from 'axios'
import { convertAndFormatToUserTimezone } from '@/util/date';
import { toolkitUrls } from '@/links'
// The date is "2050-01-22T14:00:00.000+00:00" - this removes everything after the ".". Not doing so affects the timezone conversion.
const getDateStr = date => date.split('.')[0]

export const getUpcomingWebinars = async () => {
  const url = `${toolkitUrls.upcomingWebinars}`
  try {
    const res = await axios({
      method: 'get',
      url,
    })
    if (!(res?.data?.length ?? 0)) {
      return []
    }

    return res.data
      .map(w => { // convert to human readable date
        const webinarDateObj = new Date(getDateStr(w.date))
        return {...w, date: convertAndFormatToUserTimezone(webinarDateObj)}
      })
  } catch (err) {
    console.error('Error fetching webinars', err)
  }
}